import{Button as yt,InlineMessage as Lt,Input as At,Row as wt}from"@appcues/sonar";import{useForm as St}from"react-hook-form";import{Button as vt,Form as ht,InlineMessage as kt,Input as bt}from"@appcues/sonar";import It,{css as Nt}from"styled-components";var xt=Nt`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`,Ee=It(ht)`
  padding: var(--spacing-regular);
  padding-bottom: 0;

  ${vt} {
    flex: 1;
  }

  ${bt} {
    flex: 2;
    ${xt};
  }

  ${kt} {
    padding-top: var(--spacing-small);
  }
`;import{jsx as ue,jsxs as Be}from"react/jsx-runtime";var W=({user:e,isSpoofing:t,onSpoof:i})=>{let{register:n,handleSubmit:r,formState:{errors:s,isSubmitting:a},setError:g}=St(),{isAdmin:c}=e!=null?e:{};return!c||t?null:Be(Ee,{onSubmit:r(async({accountId:p})=>{try{await i(p)}catch(h){g("accountId",{message:"Failed to spoof"})}}),children:[Be(wt,{xAlign:"center",spacing:"small",children:[ue(At,{id:"accountId",placeholder:"Account ID",type:"number",...n("accountId",{required:"Can't be empty"})}),ue(yt,{type:"submit",disabled:a,children:"Spoof"})]}),s.accountId&&ue(Lt,{variant:"error",children:s.accountId.message})]})};import Fe from"styled-components";var We=Fe.header`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
  padding-top: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
`,De=Fe.span`
  align-items: center;
  color: var(--color-blurple-600);
  display: flex;
  font-size: var(--icon-size-large);
  justify-content: center;

  svg {
    height: 30px;
    width: 24px;

    path {
      fill: currentColor;
    }
  }
`;import{jsx as D}from"react/jsx-runtime";var $=({size:e="regular"})=>D(We,{$size:e,children:D("a",{href:"/",children:D(De,{children:D("svg",{viewBox:"0 0 1600 2000",xmlns:"http://www.w3.org/2000/svg",role:"img","aria-label":"Appcues logo",children:D("path",{d:"M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z"})})})})});import H from"styled-components";import{Stack as Tt}from"@appcues/sonar";var $e=H(Tt).attrs({spacing:"none"})`
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  width: 240px;
  background-color: var(--color-neutral-0);
  border-right: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  /*
  * This z-index is chosen because it is bigger than the biggest z-index currently
  * found in studio excluding Modals, which is in the studio classic TabsRoot
  * component (z-index: 3000). We will look at standardizing our use of z-index in
  * studio in the future.
  */
  z-index: 4000;
`,He=H.div`
  overflow-y: auto;
  flex-grow: 1;
`,ze=H.nav`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`,Oe=H.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
  padding-bottom: var(--spacing-small);
  padding-top: var(--spacing-small);
  list-style-type: none;
`,X=H.div`
  width: 18px;
  height: 14px;
`;import{Icon as Pt,Row as Ct,Text as Mt}from"@appcues/sonar";import Ue from"styled-components";import{Text as Ge}from"@appcues/sonar";var Y=Ue.li`
  a {
    height: 40px;
    display: flex;
    text-decoration: none;
    padding-left: var(--spacing-large);
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }
    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${Ge} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,_e=Ue.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${Ge} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as J,jsxs as Rt}from"react/jsx-runtime";var Ve=({children:e,icon:t,iconElement:i,NavLink:n,to:r,end:s,isActive:a,className:g,external:c=!1,isSubItem:d=!1,...p})=>J(Y,{className:g,children:J(c||!n?"a":n,{isSubItem:d,to:r,end:s,className:a?"active":"",...p,children:Rt(Ct,{spacing:"small",yAlign:"center",children:[i&&i,t&&J(Pt,{icon:t,colorToken:"foreground-secondary",size:"small"}),J(Mt,{colorToken:"foreground-primary",children:e})]})})});import{useState as Dt}from"react";import{Accordion as $t,Row as Ht}from"@appcues/sonar";import{Accordion as Q,Icon as Wt}from"@appcues/sonar";import z,{css as Je}from"styled-components";import fe,{css as Et}from"styled-components";import{Row as Bt,Text as Ke}from"@appcues/sonar";var Ft=Et`
  padding: 0 var(--spacing-regular);
`,Z=fe.div`
  a {
    height: ${({variant:e="regular"})=>e==="regular"?"40px":"64px"};
    display: flex;
    text-decoration: none;
    padding: 0 var(--spacing-large);
    ${({isSubItem:e})=>e&&Ft}
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }

    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${Ke} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,qe=fe(Bt)`
  max-width: 100%;
`,Xe=fe(Ke).attrs({forwardedAs:"span"})`
  flex: 1;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;var ve=Je`
  fill: var(--color-blurple-600);
`,he=z(Wt)`
  display: block;
  // 18px is used so that the accordion icon aligns with the other nav item icons
  width: 18px;

  path {
    transition: fill 0.3s ease;
    // The active state is determined programatically because when the accordion is closed the active list item is reomved from the DOM
    ${({$isActive:e})=>e&&ve}
  }
`,Ye=Je`
  background-color: var(--color-neutral-50);
  border-radius: var(--border-radius-small);
`,Ze=z(Q.Header)`
  height: 40px;
  display: flex;
  // The Sonar Accordion.Header has some padding that we need to override so that the correct hover background can be applied
  padding: 0;
  font-weight: var(--font-weight-regular);
  transition: background-color 0.3s ease;

  :hover {
    ${Ye};

    ${he} {
      path {
        ${ve};
      }
    }
  }

  /* Shows accordion header as active if collapsed */
  &[data-state='closed'] {
    ${({$isActive:e})=>e&&Ye};
  }
`,Qe=z(Q.Trigger)`
  color: var(--foreground-primary);
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
`,je=z(Q.Content)`
  p {
    // Padding of 26px is required so that the accordion content aligns correctly with the other nav item text
    padding-left: 26px;
  }

  // We don't want padding on the last list item because a 4px space is already provided by the flex gap
  li {
    &:not(:last-child) {
      padding-bottom: var(--spacing-x-small);
    }
  }
`,eo=z(Q.Item)`
  // These styles create a gap between the trigger and the content when the accordion is expanded, but
  // the gap is removed when the accordion is collapsed
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);

  // This selector is used to apply the blurple fill to the accordion icon when one of it's children is hovered
  &:has(div > li > a:hover) {
    div > svg > path {
      ${ve}
    }
  }

  ${Z} {
    margin-left: var(--spacing-x-large);
    margin-right: var(--spacing-small);
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      background-color: var(--color-neutral-300);
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`;import{jsx as O,jsxs as to}from"react/jsx-runtime";var zt="@navigation/accordion_",oo={getAccordionKey(e){return`${zt}${e}`},getAccordionValue(e){let t=this.getAccordionKey(e);return localStorage.getItem(t)},setAccordionValue(e,t){let i=this.getAccordionKey(e);Boolean(t)?localStorage.setItem(i,t):localStorage.removeItem(i)}},no=({children:e,text:t,icon:i,isActive:n})=>{let r=()=>{if(n)return t;let c=oo.getAccordionValue(t);if(c)return c},[s,a]=Dt(r()),g=c=>{a(c),oo.setAccordionValue(t,c)};return O($t.Root,{collapsible:!0,value:s,onValueChange:g,type:"single",$unstyled:!0,children:to(eo,{value:t,children:[O(Ze,{$isActive:n,children:O(Qe,{children:to(Ht,{spacing:"small",yAlign:"center",children:[O(he,{icon:i,colorToken:"color-neutral-700",size:"small",$isActive:n}),t]})})}),O(je,{children:e})]})})};import{jsx as io}from"react/jsx-runtime";var ao=({children:e,isActive:t,onClick:i})=>io(Y,{children:io(_e,{onClick:i,className:t?"active":"",children:e})});import{Icon as ro,Row as so,Text as Ot}from"@appcues/sonar";import{faChevronRight as Ut}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{jsx as j,jsxs as lo}from"react/jsx-runtime";var po=({icon:e,label:t})=>lo(so,{xAlign:"space-between",yAlign:"center",children:[lo(so,{spacing:"small",yAlign:"center",children:[j(X,{children:j(ro,{icon:e,colorToken:"foreground-secondary",size:"small"})}),j(Ot,{colorToken:"foreground-primary",forwardedAs:"span",children:t})]}),j(ro,{icon:Ut,colorToken:"foreground-secondary",size:"small"})]});import{forwardRef as Gt}from"react";import{Icon as _t,NavigationMenu as Vt}from"@appcues/sonar";import{jsx as M,jsxs as Kt}from"react/jsx-runtime";var co=Gt(({children:e,icon:t,iconElement:i,NavLink:n,to:r,end:s,isActive:a,external:g=!1,isSubItem:c,variant:d="regular",title:p,...h},u)=>{let b=g||!n?"a":n;return M(Z,{isSubItem:c,variant:d,className:"accordion-link-item",children:M(Vt.Link,{asChild:!0,children:M(b,{ref:u,to:r,end:s,className:a?"active":"",...h,children:Kt(qe,{fluid:!0,spacing:"small",yAlign:"center",children:[i&&i,t&&M(X,{children:M(_t,{icon:t,colorToken:"foreground-secondary",size:"small"})}),M(Xe,{colorToken:"foreground-primary",title:p||"",children:e})]})})})})});import{NavigationMenu as Yt}from"@appcues/sonar";import qt from"styled-components";import{Text as Xt}from"@appcues/sonar";var mo=qt.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;
  border: 0;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${Xt} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as go}from"react/jsx-runtime";var uo=({children:e,onClick:t,className:i})=>go(Yt.Link,{asChild:!0,children:go(mo,{onClick:t,className:i,children:e})});var o={Wrapper:$e,ScrollContainer:He,NavList:Oe,Nav:ze,NavItem:Ve,NavButton:ao,NavAccordion:no,NavTrigger:po,LinkItem:co,ButtonItem:uo};import{useEffect as ke}from"react";function fo({user:e,account:t,cannyAppId:i,isOpen:n}){ke(()=>{if(window.Canny&&t&&e){let{id:r,isTrial:s,tier:a,stripePlanId:g}=t,{fullname:c,email:d,id:p,job:h,crxVersion:u}=e;window.Canny("identify",{appID:i,user:{email:d,name:c||"anonymous",id:p,customFields:{job:h,crxVersion:u},companies:[{customFields:{isTrial:s,tier:a,stripePlanId:g},id:r,name:r}]}})}},[t,i,e]),ke(()=>{!n&&window.Canny&&window.Canny("closeChangelog")},[n]),ke(()=>{new MutationObserver(()=>{if(document.querySelector("[data-canny-changelog]"))try{window.Canny("initChangelog",{appID:i,position:"right",align:"bottom"})}catch(a){}}).observe(document.body,{childList:!0,subtree:!0})},[i])}import{Icon as an,Row as rn,Tooltip as sn}from"@appcues/sonar";import{faScrewdriverWrench as ln}from"@fortawesome/pro-solid-svg-icons/faScrewdriverWrench";import G from"styled-components";import{Button as tn,Stack as nn,NavigationMenu as xo}from"@appcues/sonar";import{Progress as en}from"@appcues/sonar";import on from"pluralize";import{differenceInDays as Jt}from"date-fns";var be=(e,t)=>Jt(e,t),vo=e=>new Intl.DateTimeFormat(void 0,{year:"numeric",month:"short",day:"2-digit"}).format(e);var Ie=(e,t)=>!((e==null?void 0:e.stripePlanId)||(t==null?void 0:t.isExpired));import U from"styled-components";import{Skeleton as Zt}from"@studio/legacy-components";import{Button as Qt,Tooltip as jt}from"@appcues/sonar";var ho=U.div`
  text-align: center;
  gap: 8px;
  padding: 16px 24px 0 24px;
  display: flex;
  flex-direction: column;

  ${Zt} {
    width: 140px;
    height: 40px;
    margin: 0 auto;
  }

  ${Qt} {
    --link-color: #ffffff;
    --link-text-decoration: none;
    --link-visited-color: #ffffff;
  }
`,ko=U.div`
  font-weight: 700;
  color: rgb(57, 68, 85);
  font-size: 14px;
`,bo=U.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
`,Io=U.div`
  width: 180px;
  white-space: pre-wrap;
  font-size: 0.75rem;
`,No=U(jt)`
  width: 100%;
`;import{jsx as ee,jsxs as Ne}from"react/jsx-runtime";var xe=({account:e={},trialStatus:t={},className:i,Link:n})=>{let{createdAt:r,expirationDate:s,isWebInstalled:a,lengthDays:g}=t;if(!Ie(e,t)||!r||!s)return null;let d=be(new Date(s),new Date(r))+1,p=be(new Date(s),new Date)+1,u=(d-p)/d,b=Math.round(u*100),y=p>7?"default":(p>3,"error"),L=Ne(Io,{children:["Trial expires on ",vo(new Date(s)),"."," ",a?"":`Install the Appcues SDK to extend your trial another ${g} days.`]});return Ne(ho,{className:i,children:[ee(No,{placement:"right",content:L,children:Ne(bo,{children:[ee(ko,{children:`${p} ${on("day",p)} left in trial`}),ee(en,{value:b,max:100,variant:y})]})}),ee(n,{to:"/subscription",children:"Upgrade now"})]})};var oe=G(xo.Trigger)`
  height: 40px;
`,yo=G(nn).attrs({spacing:"large"})`
  padding: var(--spacing-large);
`,Lo=G(xe)`
  padding: 0;
`,ye=G(tn)`
  width: 100%;
  text-decoration: none;
`,R=G(xo.Content)`
  position: absolute;
  transform: translateY(-40px);
  left: 100%;
  margin-left: var(--spacing-x-small);
  background-color: var(--color-neutral-0);
  border-radius: var(--border-radius-small);
  gap: var(--spacing-x-small);
  padding: var(--spacing-small) var(--spacing-x-small);
  box-shadow: var(--elevation-300);
  transform: translateY(-40px);
  width: 200px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;import{jsx as _,jsxs as Ao}from"react/jsx-runtime";var wo=({NavLink:e,isInstalled:t,account:i,trialStatus:n})=>Ao(yo,{children:[t?null:_(sn,{size:"regular",content:"In order to publish live experiences to your users, you'll have to install Appcues directly into your codebase. Don't worry...it's super easy. Click here to learn how!",children:_(ye,{variant:"secondary",fluid:!0,forwardedAs:e,to:"/settings/installation",children:Ao(rn,{spacing:"small",yAlign:"center",children:[_(an,{icon:ln}),"Install"]})})}),_(Lo,{account:i,trialStatus:n,Link:r=>_(ye,{variant:"tertiary",forwardedAs:e,...r})})]});import{useState as Eo}from"react";import{faGear as gn}from"@fortawesome/pro-solid-svg-icons/faGear";import{faChevronRight as dn}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{faExternalLink as un}from"@fortawesome/pro-solid-svg-icons/faExternalLink";import{faArrowRightFromBracket as fn}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{Icon as ne,Row as Ae,Stack as vn,Text as we,NavigationMenu as ie}from"@appcues/sonar";import w from"styled-components";import{Text as So,Stack as pn,Row as cn}from"@appcues/sonar";import{Separator as mn}from"@radix-ui/react-separator";var To=w(pn).attrs({spacing:"x-small"})`
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,Po=w(R)`
  transform: translateY(-105%);
  width: 237px;
`,Co=w(cn)`
  max-width: calc(100% - var(--spacing-large));
`,te=w(So).attrs({colorToken:"foreground-primary",forwardedAs:"span",weight:"bold"})`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`,Mo=w.div`
  display: flex;
  padding: var(--spacing-small) var(--spacing-regular);
  cursor: pointer;
`,Ro=w(So)`
  padding-left: 22px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`,Le=w(mn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
`;import{jsx as v,jsxs as A}from"react/jsx-runtime";var Bo=({NavLink:e,onLogout:t,user:{email:i,fullName:n}={},companyName:r,accountsCount:s})=>{let a=r||i||"",[g,c]=Eo(),[d,p]=Eo(!1),h=u=>{g&&!d&&(u.preventDefault(),p(!0)),g&&d&&p(!1)};return v(ie.Root,{orientation:"vertical",value:g,onValueChange:u=>{c(u),u||p(!1)},children:v(ie.List,{children:A(ie.Item,{value:"account-menu",children:[v(ie.Trigger,{onClick:h,children:A(To,{children:[A(Ae,{xAlign:"space-between",yAlign:"center",children:[A(Co,{spacing:"small",yAlign:"center",children:[v(ne,{icon:gn,colorToken:"foreground-secondary",size:"small"}),v(te,{title:a,children:a})]}),v(ne,{icon:dn,colorToken:"foreground-secondary",size:"small"})]}),n&&v(Ro,{title:n,size:"small",children:n})]})}),v(Po,{children:A("ul",{children:[s>1?v(o.LinkItem,{isSubItem:!0,variant:"tall",NavLink:e,to:"/accounts-v2",children:A(vn,{spacing:"x-small",children:[v(te,{title:a,children:a}),v(we,{size:"small",children:"Switch Accounts"})]})}):v(Mo,{children:v(te,{title:a,children:a})}),v(Le,{}),v(o.LinkItem,{isSubItem:!0,NavLink:e,to:"/settings/account",children:"Settings"}),v(o.LinkItem,{external:!0,isSubItem:!0,"data-canny-link":!0,href:"https://feedback.appcues.com/product-feedback?sort=top",target:"_blank",children:"Suggest a feature"}),v(o.LinkItem,{external:!0,isSubItem:!0,href:"https://status.appcues.com",target:"_blank",children:A(Ae,{xAlign:"space-between",yAlign:"center",children:[v(we,{forwardedAs:"span",children:"Appcues status"}),v(ne,{icon:un,colorToken:"foreground-link"})]})}),v(Le,{}),v("li",{children:v(o.ButtonItem,{onClick:t,children:A(Ae,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[v(we,{colorToken:"foreground-primary",forwardedAs:"span",children:"Sign out"}),v(ne,{colorToken:"foreground-secondary",icon:fn})]})})})]})})]})})})};import E from"styled-components";import{NavigationMenu as Fo,Row as hn}from"@appcues/sonar";import{Separator as kn}from"@radix-ui/react-separator";var B=E(kn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
  padding: 0.1px 0 0 0;
`,ae=E.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  height: 100%;
  overflow-y: auto;
`,Wo=E(Fo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  & ul {
    list-style-type: none;
  }
`,Do=E(Fo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;

  & ul {
    list-style-type: none;
  }
`,V=E.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
`,$o=E(hn).attrs({spacing:"x-small",yAlign:"center",xAlign:"center"})`
  background: var(--color-neutral-100);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-x-small);
  color: var(--foreground-secondary);

  svg path {
    fill: var(--foreground-secondary) !important;
  }
`;import{useState as Vo}from"react";import{NavigationMenu as le}from"@appcues/sonar";import{faFolderMagnifyingGlass as Rn}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as En}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as Bn}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faUsers as zo}from"@fortawesome/pro-solid-svg-icons/faUsers";import{faArrowsTurnToDots as bn}from"@fortawesome/pro-solid-svg-icons/faArrowsTurnToDots";import{faMessages as In}from"@fortawesome/pro-solid-svg-icons/faMessages";import{faMap as Oo}from"@fortawesome/pro-solid-svg-icons/faMap";import{faThumbtack as Nn}from"@fortawesome/pro-solid-svg-icons/faThumbtack";import{faCheckCircle as xn}from"@fortawesome/pro-solid-svg-icons/faCheckCircle";import{faComment as yn}from"@fortawesome/pro-solid-svg-icons/faComment";import{faRocket as Ln}from"@fortawesome/pro-solid-svg-icons/faRocket";import{faChartColumn as Uo}from"@fortawesome/pro-solid-svg-icons/faChartColumn";import{faBullseye as An}from"@fortawesome/pro-solid-svg-icons/faBullseye";import{faChartPieSimple as wn}from"@fortawesome/pro-solid-svg-icons/faChartPieSimple";import{faBuildings as Sn}from"@fortawesome/pro-solid-svg-icons/faBuildings";import{faTh as Tn}from"@fortawesome/pro-solid-svg-icons/faTh";import{faRectangleCode as Pn}from"@fortawesome/pro-solid-svg-icons/faRectangleCode";import{NavigationMenu as re}from"@appcues/sonar";import{faEnvelopeOpen as Cn}from"@fortawesome/pro-solid-svg-icons";import{jsx as Ho}from"react/jsx-runtime";var F=()=>Ho("svg",{width:"18",height:"16",viewBox:"0 0 18 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:Ho("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.1258 5L14.902 8.00085L17.1246 11H1.1258L3.34967 7.99915L1.12706 5H17.1258ZM0.874146 11H0.874181L0.874181 5H0.874146V11Z",fill:"var(--foreground-secondary)"})});import{Fragment as Mn,jsx as f,jsxs as S}from"react/jsx-runtime";var Go={MESSAGING:[/^\/banners(\/.*)?$/,/^\/pins(\/.*)?$/,/^\/checklists(\/.*)?$/,/^\/nps(\/.*)?$/,/^\/nps-v2(\/.*)?$/,/^\/launchpads(\/.*)?$/,/^\/flows-v2(\/.*)?$/,/^\/embeds(\/.*)?$/],METRICS:[/^\/goals(\/.*)?$/,/^\/insights\/explorer(\/.*)?$/,/^\/insights\/charts(\/.*)?$/,/^\/email-performance(\/.*)?$/]},se=(e,t)=>t.some(i=>e.startsWith(i)),_o=(e,t)=>t.some(i=>i.test(e)),Se=({NavLink:e,currentPath:t,featureFlags:i,handleClick:n})=>{let{hasLaunchpads:r,hasNps2:s}=i,a=se(t,["/flows","/mobile","/experiments"]),g=_o(t,[...Go.MESSAGING])||a,c=se(t,["/audience/segments","/segments"]),d=se(t,["/audience/users"]),p=se(t,["/audience"])||c||d,h=_o(t,[...Go.METRICS]);return S(Mn,{children:[f(re.Item,{children:f(o.LinkItem,{icon:bn,NavLink:e,to:"/workflows",children:"Workflows"},"/workflows")}),S(re.Item,{value:"messaging-menu",children:[f(oe,{className:g?"active":"",onClick:u=>n(u,"messaging-menu"),children:f(o.NavTrigger,{icon:In,label:"Messaging"})}),f(R,{children:S("ul",{children:[f(o.LinkItem,{icon:Oo,NavLink:e,to:"/flows",isSubItem:!0,isActive:a,children:"Flows"},"/flows"),f(o.LinkItem,{icon:Oo,NavLink:e,to:"/flows-v2",isSubItem:!0,children:"Flows 2.0"},"/flows-v2"),f(o.LinkItem,{icon:Pn,NavLink:e,to:"/embeds",isSubItem:!0,children:"Embeds"},"/embeds"),f(o.LinkItem,{iconElement:f(F,{}),NavLink:e,to:"/banners",isSubItem:!0,children:"Banners"},"/banners"),f(o.LinkItem,{icon:Nn,NavLink:e,to:"/pins",isSubItem:!0,children:"Pins"},"/pins"),f(o.LinkItem,{icon:xn,NavLink:e,to:"/checklists",isSubItem:!0,children:"Checklists"},"/checklists"),f(o.LinkItem,{icon:yn,NavLink:e,to:s?"/nps-v2":"/nps",isSubItem:!0,children:"NPS"},"/nps"),r&&f(o.LinkItem,{icon:Ln,NavLink:e,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]})})]}),S(re.Item,{value:"audiences-menu",children:[f(oe,{className:p?"active":"",onClick:u=>n(u,"audiences-menu"),children:f(o.NavTrigger,{icon:zo,label:"Audiences"})}),f(R,{children:S("ul",{children:[f(o.LinkItem,{icon:wn,NavLink:e,to:"/audience/segments-v2",isSubItem:!0,isActive:c,children:"Segments"},"/audience/segments-v2"),f(o.LinkItem,{icon:zo,NavLink:e,to:"/audience/users-v2",isSubItem:!0,isActive:d,children:"Users"},"/audience/users-v2"),f(o.LinkItem,{icon:Sn,NavLink:e,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]})})]}),S(re.Item,{value:"metrics-menu",children:[f(oe,{className:h?"active":"",onClick:u=>n(u,"metrics-menu"),children:f(o.NavTrigger,{icon:Uo,label:"Metrics"})}),f(R,{children:S("ul",{children:[f(o.LinkItem,{icon:An,NavLink:e,to:"/goals",isSubItem:!0,children:"Goals"},"/goals"),f(o.LinkItem,{icon:Uo,NavLink:e,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),f(o.LinkItem,{icon:Tn,NavLink:e,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),f(o.LinkItem,{icon:Cn,NavLink:e,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]})})]})]})};import{jsx as x,jsxs as Fn}from"react/jsx-runtime";function Te({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:r,actions:s,currentPath:a,hasLaunchpads:g,hasNps2:c,hasDevTools:d}){let[p,h]=Vo(),[u,b]=Vo({}),y=(I,k)=>{p===k&&!u[k]&&(I.preventDefault(),b({[k]:!0})),p===k&&u[k]&&b({[k]:!1})},L=(I,k)=>{y(I,k)};return x(Wo,{orientation:"vertical",value:p,onValueChange:I=>{h(I),I||b({})},children:x(le.List,{children:Fn(ae,{children:[e&&s?s:null,t&&!i?null:x(le.Item,{children:x(o.LinkItem,{icon:En,NavLink:n,to:"/",end:r,children:"Overview"})}),x(V,{children:x(Se,{NavLink:n,currentPath:a,handleClick:(I,k)=>L(I,k),featureFlags:{hasLaunchpads:g,hasNps2:c}})}),x(B,{}),x(le.Item,{children:x(o.LinkItem,{icon:Rn,NavLink:n,to:"/folders",children:"Folders"})}),d&&x(le.Item,{children:x(o.LinkItem,{icon:Bn,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{Icon as Wn,NavigationMenu as Pe,Row as Dn}from"@appcues/sonar";import{trackEvent as $n}from"@studio/analytics";import{faArrowsTurnToDots as Hn,faMessages as zn,faMap as Ko,faThumbtack as On,faCheckCircle as Un,faComment as Gn,faChartColumn as qo,faBullseye as _n,faEnvelopeOpen as Vn,faTh as Kn,faUsers as Xo,faChartPieSimple as qn,faBuildings as Xn,faRocket as Yn,faChartLine as Jn,faFlask as Zn,faRectangleCode as Qn,faLightbulb as jn,faBarsFilter as ei,faGauge as oi}from"@fortawesome/pro-solid-svg-icons";import{faFolderMagnifyingGlass as ti}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as ni}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as ii}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faSparkles as ai}from"@fortawesome/pro-regular-svg-icons";import{jsx as l,jsxs as T}from"react/jsx-runtime";var ri=["/flows","/pins","/banners","/checklists","/nps","/embeds"],si=["/flows","/flows-v2"],li=["/goals","/insights/explorer","/insights/charts","/insights/funnels","/email-performance"],pi=["/audience/segments-v2","/audience/users-v2","/audience/accounts"],pe=(e,t)=>e.some(i=>t.startsWith(i));function Ce({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:r,actions:s,currentPath:a,hasNps2:g,hasDevTools:c,hasAiInsights:d,hasFunnels:p,hasDashboards:h}){let u=pe(ri,a),b=pe(li,a),y=pe(pi,a),L=pe(si,a);return l(Do,{orientation:"vertical",children:l(Pe.List,{children:T(ae,{children:[e&&s?s:null,T(V,{children:[h&&l(o.LinkItem,{icon:oi,NavLink:n,to:"/dashboards",children:"Dashboards"}),t&&!i?null:l(o.LinkItem,{icon:ni,NavLink:n,to:"/",end:r,children:"Overview"}),d&&l(o.LinkItem,{NavLink:n,to:"/insights-feed",icon:jn,onClick:()=>{$n({name:"nav_click",properties:{navItemID:"insights-feed",navItemName:"Insights"}})},children:T(Dn,{xAlign:"space-between",yAlign:"center",spacing:"small",children:["Insights",l($o,{children:l(Wn,{icon:ai,size:"small"})})]})})]}),T(V,{children:[T(o.NavAccordion,{isActive:u,text:"Experiences",icon:zn,children:[l(o.LinkItem,{NavLink:n,to:"/flows",icon:Ko,isActive:L,isSubItem:!0,children:"Flows"},"/flows"),l(o.LinkItem,{icon:Ko,NavLink:n,to:"/flows-v2",isSubItem:!0,title:"Flows 2.0",children:"Flows 2.0"},"/flows-v2"),l(o.LinkItem,{icon:Qn,NavLink:n,to:"/embeds",isSubItem:!0,title:"Embeds",children:"Embeds"},"/embeds"),l(o.LinkItem,{NavLink:n,to:"/pins",icon:On,isSubItem:!0,children:"Pins"},"/pins"),l(o.LinkItem,{NavLink:n,to:"/banners",iconElement:l(F,{}),isSubItem:!0,children:"Banners"},"/banners"),l(o.LinkItem,{NavLink:n,to:"/checklists",icon:Un,isSubItem:!0,children:"Checklists"},"/checklists"),l(o.LinkItem,{NavLink:n,to:g?"/nps-v2":"/nps",icon:Gn,isSubItem:!0,children:"NPS"},"/nps"),l(o.LinkItem,{icon:Yn,NavLink:n,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]}),T(o.NavAccordion,{isActive:b,text:"Metrics",icon:qo,children:[l(o.LinkItem,{NavLink:n,to:"/goals",icon:_n,isSubItem:!0,children:"Goals"},"/goals"),l(o.LinkItem,{icon:qo,NavLink:n,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),l(o.LinkItem,{icon:Kn,NavLink:n,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),p&&l(o.LinkItem,{icon:ei,NavLink:n,to:"/insights/funnels",isSubItem:!0,children:"Funnels"},"/insights/funnels"),l(o.LinkItem,{NavLink:n,to:"/experiments",icon:Zn,isSubItem:!0,children:"Experiments"},"/experiments"),l(o.LinkItem,{NavLink:n,to:"/performance",icon:Jn,isSubItem:!0,children:"Flow Performance"},"/performance"),l(o.LinkItem,{title:"Email Performance",icon:Vn,NavLink:n,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]}),T(o.NavAccordion,{isActive:y,text:"Audiences",icon:Xo,children:[l(o.LinkItem,{icon:qn,NavLink:n,to:"/audience/segments-v2",isSubItem:!0,children:"Segments"},"/audience/segments-v2"),l(o.LinkItem,{icon:Xo,NavLink:n,to:"/audience/users-v2",isSubItem:!0,children:"Users"},"/audience/users-v2"),l(o.LinkItem,{icon:Xn,NavLink:n,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]}),l(o.LinkItem,{NavLink:n,to:"/workflows",icon:Hn,children:"Workflows"},"/workflows")]}),l(B,{}),l(Pe.Item,{children:l(o.LinkItem,{icon:ti,NavLink:n,to:"/folders",children:"Folders"})}),c&&l(Pe.Item,{children:l(o.LinkItem,{icon:ii,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{jsx as P,jsxs as ci}from"react/jsx-runtime";var Yo=({user:e,account:t,accountsCount:i,onSpoof:n,onLogout:r,isSpoofing:s,NavLink:a,featureFlags:g,matchExactRoutes:c,isInstalled:d,trialStatus:p,cannyAppId:h,currentPath:u,actions:b})=>{let{hasDevTools:y,hasLaunchpads:L,hasOverviewRedirect:I,hasAiAssistant:k,hasNps2:q,hasNav2025:ge,hasAiInsights:de,hasFunnels:N,hasDashboards:ft}=g;return fo({user:e,account:t,cannyAppId:h,isOpen:!1}),ci(o.Wrapper,{children:[P(W,{user:e,onSpoof:n,isSpoofing:s}),P($,{size:"large"}),ge?P(Ce,{hasDevTools:y,hasOverviewRedirect:I,isInstalled:d,NavLink:a,matchExactRoutes:c,actions:b,currentPath:u,hasNps2:q,hasAiAssistant:k,hasAiInsights:de,hasFunnels:N,hasDashboards:ft}):P(Te,{hasDevTools:y,hasLaunchpads:L,hasOverviewRedirect:I,isInstalled:d,NavLink:a,matchExactRoutes:c,actions:b,currentPath:u,hasNps2:q,hasAiAssistant:k}),P(wo,{NavLink:a,isInstalled:d,account:t,trialStatus:p}),P(B,{}),P(Bo,{user:e,companyName:t==null?void 0:t.name,NavLink:a,accountsCount:i,onLogout:r})]})};import{faCircleUser as bi}from"@fortawesome/pro-solid-svg-icons/faCircleUser";import{faPeopleGroup as Ii}from"@fortawesome/pro-solid-svg-icons/faPeopleGroup";import{faCreditCard as Ni}from"@fortawesome/pro-regular-svg-icons/faCreditCard";import{faLaptopMobile as xi}from"@fortawesome/pro-solid-svg-icons/faLaptopMobile";import{faPaperPlane as yi}from"@fortawesome/pro-solid-svg-icons/faPaperPlane";import{faPlug as Li}from"@fortawesome/pro-solid-svg-icons/faPlug";import{faDatabase as Ai}from"@fortawesome/pro-solid-svg-icons/faDatabase";import{faGlobe as wi}from"@fortawesome/pro-solid-svg-icons/faGlobe";import{faSparkles as Si}from"@fortawesome/pro-solid-svg-icons/faSparkles";import{faArrowRightFromBracket as Ti}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{faPalette as Pi}from"@fortawesome/pro-solid-svg-icons/faPalette";import{Icon as Ci,NavigationMenu as et,Row as Mi,Text as Ri}from"@appcues/sonar";import mi from"styled-components";import{Button as gi,Icon as di,Text as ui,Tooltip as fi}from"@appcues/sonar";import{faChevronLeft as vi}from"@fortawesome/pro-solid-svg-icons/faChevronLeft";import{jsx as K}from"react/jsx-runtime";var hi=mi.div`
  justify-self: end;
`,Jo=({onClick:e})=>K(hi,{children:K(fi,{content:K(ui,{size:"small",lineHeight:"large",colorToken:"foreground-tooltip",children:"Exit settings"}),placement:"bottom",children:K(gi,{title:"back link",variant:"tertiary",iconOnly:!0,onClick:e,children:K(di,{icon:vi})})})});import{Text as ki}from"@appcues/sonar";import Me from"styled-components";var Zo=Me(ki)`
  padding-left: var(--spacing-large);
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,Qo=Me.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
`,jo=Me.div`
  padding-bottom: var(--spacing-small);
`;import{jsx as m,jsxs as C}from"react/jsx-runtime";var Ei=new Set(["/settings/integrations","/webhooks","/settings/keys","/integrations/webhooks","/integrations/connections"]),Bi=new Set(["/settings/events","/settings/properties","/settings/properties/users","/settings/properties/groups"]),Fi=["/settings/themes",/^\/themes(\/.*)?$/],Wi=["/settings/installation",/apps\/[^/]+$/],Di=["/settings/emails/senders",/\/settings\/emails\/suppression-lists\/[^/]+$/],ot=({NavLink:e,featureFlags:t,currentPath:i,user:n,onSpoof:r,isSpoofing:s,onClickBackArrow:a,onClickLogout:g,hasLocalizationAccess:c,actions:d})=>{let{hasIntegrationPageRedesign:p,hasMobileFlows:h,hasAIAssistant:u,hasSubscription:b}=t,y=Ei.has(i),L=Fi.some(N=>typeof N=="string"?N===i:N.test(i)),I=Bi.has(i),k=Wi.some(N=>typeof N=="string"?N===i:N.test(i)),q=Di.some(N=>typeof N=="string"?N===i:N.test(i)),ge=i.includes("/settings/emails/suppression-lists/"),de=i.startsWith("/settings/properties");return C(o.Wrapper,{children:[m(W,{user:n,onSpoof:r,isSpoofing:s}),C(Qo,{children:[m(Jo,{onClick:a}),m($,{})]}),m(et.Root,{orientation:"vertical",children:m(et.List,{children:u&&d?d:null})}),m(Zo,{size:"medium",weight:"semibold",children:"Settings"}),m(o.ScrollContainer,{children:m(o.Nav,{children:C(o.NavList,{children:[m(o.NavItem,{icon:bi,NavLink:e,to:"/settings/account",children:"Profile"}),m(o.NavItem,{icon:Ii,NavLink:e,to:"/settings/team",children:"Team"}),b&&m(o.NavItem,{icon:Ni,NavLink:e,to:"/settings/subscription",children:"Subscription"}),m(o.NavItem,{icon:xi,NavLink:e,to:"/settings/installation",isActive:k,children:h?"Apps & Installation":"Installation"}),m(o.NavItem,{icon:Pi,NavLink:e,to:"/settings/themes",isActive:L,children:"Themes"}),u&&m(o.NavItem,{icon:Si,NavLink:e,to:"/settings/ai-assistant",children:"Appcues AI"}),C(o.NavAccordion,{text:"Emails",icon:yi,isActive:q,children:[m(o.NavItem,{NavLink:e,to:"/settings/emails/senders",children:"Senders"}),m(o.NavItem,{NavLink:e,to:"/settings/emails/suppression-lists/unsubscribes",isActive:ge,children:"Suppression Lists"}),m(o.NavItem,{NavLink:e,to:"/settings/emails/sending-behavior",children:"Sending Behavior"})]}),C(o.NavAccordion,{text:"Integrations",icon:Li,isActive:y,children:[m(o.NavItem,{NavLink:e,to:p?"/integrations/connections":"/settings/integrations",children:"Connections"}),m(o.NavItem,{NavLink:e,to:"/integrations/webhooks",children:"Webhooks"}),m(o.NavItem,{NavLink:e,to:"/settings/keys",children:"API Keys"})]}),C(o.NavAccordion,{text:"Data",icon:Ai,isActive:I,children:[m(o.NavItem,{NavLink:e,to:"/settings/identifier",children:"Accounts & Users"}),m(o.NavItem,{NavLink:e,to:"/settings/events",children:"Events"}),m(o.NavItem,{NavLink:e,to:"/settings/properties/user",isActive:de,children:"Properties"})]}),c&&m(o.NavItem,{icon:wi,NavLink:e,to:"/settings/localization",children:"Localization"})]})})}),m(o.NavList,{children:m(jo,{children:m(o.NavButton,{onClick:g,children:C(Mi,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[m(Ri,{colorToken:"foreground-primary",children:"Sign out "}),m(Ci,{colorToken:"foreground-secondary",size:"small",icon:Ti})]})})})})]})};import $i from"styled-components";var tt=$i.div`
  flex: 0 0 220px;
  width: 220px;
  position: fixed;
  height: 100vh;
  background-color: var(--color-neutral-100);
  border-right: 1px solid var(--border-default);
  bottom: 0;
  left: 0;
  top: 0;
  z-index: 100;
`;import{jsx as Hi}from"react/jsx-runtime";var nt=()=>Hi(tt,{});import{useCallback as zi,useEffect as Oi,useRef as Ui}from"react";import{createPopup as Gi}from"@typeform/embed";var _i={unmount:()=>{},open:()=>{}},Vi="QD5X3rU2";function it({size:e=60,formValues:t={}}){let i=Ui(_i);return Oi(()=>{let r={size:e,hidden:t};i.current=Gi(Vi,r)},[i,e,t]),{handleClick:zi(()=>i.current.open(),[i])}}import at from"styled-components";import{Link as Ki}from"@appcues/sonar";var rt=at.span`
  --font-size-regular: var(--font-size-small);
  --foreground-link: var(--color-blurple-400);
  --link-text-decoration: none;
`,st=at(Ki)``;import{jsx as lt}from"react/jsx-runtime";var pt=({children:e,message:t,subject:i,user:n,mailto:r="support@appcues.com",...s})=>{let a=(n==null?void 0:n.fullName)||(n==null?void 0:n.fullname),{email:g}=n!=null?n:{},c=["Hi,",t,"Thanks!"].join(`

`),d={message:t,subject:i,text:c,mailto:r,...a&&{name:a},...g&&{email:g}},{handleClick:p}=it({formValues:d});return lt(rt,{onClick:p,children:lt(st,{"data-testid":"typeform-beacon",icon:!1,...s,children:e})})};import{Text as Zi}from"@appcues/sonar";import qi from"styled-components";import{Link as ct}from"@appcues/sonar";import{Link as Xi}from"react-router-dom";import{jsx as mt}from"react/jsx-runtime";var Yi=({children:e,href:t,...i})=>t?mt(ct,{href:t,...i,children:e}):mt(ct,{forwardedAs:Xi,...i,children:e}),ce=qi(Yi)``;import me from"styled-components";var Ji=me.div`
  align-items: center;
  background: white;
  box-shadow: var(--elevation-200);
  display: flex;
  height: 48px;
  justify-content: center;
`,lp=me.div`
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 9000;
  min-width: 870px;
`,gt=me(Ji)`
  background: var(--color-pink-600);
  color: white;
  gap: var(--spacing-small);
`,dt=me.div``;import{jsx as Re,jsxs as ut}from"react/jsx-runtime";var Qi=()=>Re(ce,{colorToken:"white",href:"#",onClick:e=>{e.preventDefault()},children:"Stop spoofing"});function ji({accountId:e,spoofing:t,onDespoof:i}){return t?ut(gt,{"aria-live":"polite",role:"alert",children:[ut(Zi,{weight:"bold",colorToken:"white",children:["Spoofing Account ",e]}),Re(dt,{onClick:i,children:Re(Qi,{})})]}):null}export{F as BannerIcon,pt as BeaconLink,nt as BlankNavigation,ce as Link,Yo as MainNavigation,o as Navigation,ot as SettingsNavigation,ji as SpoofBanner,Ie as isTrialAccount};
//# sourceMappingURL=index.mjs.map